import { isBusinessOpen, primaryProperty, useGetAllBusinesses } from "@api/businessService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { formatDate } from "@utils/dates";
import { useDeleteProperty, useGetAllProperties } from "@api/propertyService";

import DirectionsRoundedIcon from '@mui/icons-material/DirectionsRounded';

const columns = [
    {
        id: 'address',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Address',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.address}</Typography>
                </LinkComponent>

                {row.address_2 && (<Typography fontSize="sm"><Typography>{row.address_2}</Typography></Typography>)}
            </>)
        }
      },
      {
        id: 'owner',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Owner',
        cell: (row, {LinkComponent}) => {
            if(!row.owner) {
                return 'N/A';
            }

            return (
                <LinkComponent to={`/${row.owner_type == 'App\\Models\\Contact' ? 'contacts' : 'businesses'}/${row.owner.id}`} relative={true} object={row.owner}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.owner.name}</Typography>
                </LinkComponent>
            );
            /*
            if(row.owner_type === 'App\\Models\\Contact') {
            }

            return (
                <LinkComponent to={`/businesses/${row.owner.id}`} relative={true} object={row.woner}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.owner.name}</Typography>
                </LinkComponent>
            );
            */
        }
      },
];

const listCell = (row, {LinkComponent}) => {
    return (<>
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    {row.address}
                </LinkComponent>
                {row.address_2}
            </Typography>
        </Box>
    </>);
};

const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    const destination = `${row.address} ${row.city} ${row.state_province}`;

    return (<>
        <Tooltip title="Get Directions">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!row.email}
                component={'a'}
                href={`https://www.google.com/maps/dir/?api=1&destination=${destination}`}
                target="_blank"
                >
                <DirectionsRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
};

export default function PropertyIndex() {
    return (
        <ObjectIndex
            defaultParams={{orderby: 'address'}}
            query={useGetAllProperties}
            deleteMutation={useDeleteProperty}
            type={'property'}
            permissionType={'properties'}
            title={'Properties'}
            color={'property'}
            columns={columns}
            listCell={listCell}
            listActions={listActions}
        />
    )
}
